import {ApiException} from "@/domain/core/exception/exceptions";
import {emptyListResponse} from "@/domain/core/utils/django";

const state = {
    payouts: {...emptyListResponse},
    payout: null,
    statistics: {
        total_payouts: 0,
        pending_payouts: 0,
        requested_payouts: 0,
        paid_payouts: 0,
        total_amount_pending: "0.00",
        total_amount_requested: "0.00",
        total_amount_paid: "0.00",
        total_photos_sold: 0,
        total_orders: 0,
        average_payout_amount: "0.00",
        last_payout_date: null,
        next_payout_estimated: null
    },
    contractId: null
}

export const getters = {
    payouts: state => state.payouts,
    payout: state => state.payout,
    statistics: state => state.statistics,
    contractId: state => state.contractId
}

export const mutations = {
    payouts(state, payouts) {
        state.payouts = payouts
    },
    payout(state, payout) {
        state.payout = payout
        state.payouts.results = state.payouts.results.map(p => {
            if (p.id === payout.id)
                return payout
            return p
        })
    },
    statistics(state, statistics) {
        state.statistics = statistics
    },
    contractId(state, contractId) {
        state.contractId = contractId
    }
}

export const actions = service => ({
    setContract({commit}, contractId) {
        commit('contractId', contractId)
    },
    
    async fetchPayoutList({commit, getters}, {filters, pagination, sorting}) {
        try {
            const payouts = await service.fetchPayoutList(getters.contractId, filters, pagination, sorting)
            commit('payouts', payouts)
            return payouts
        } catch (e) {
            throw new ApiException(e)
        }
    },
    
    async fetchPayoutStatistics({commit, getters}) {
        try {
            const statistics = await service.fetchPayoutStatistics(getters.contractId)
            commit('statistics', statistics)
            return statistics
        } catch (e) {
            throw new ApiException(e)
        }
    },
    
    async createPayout({dispatch, getters}) {
        try {
            // Crea nuovo payout aggregando tutti gli ordini non pagati
            const result = await service.createPayout(getters.contractId)
            await dispatch('fetchPayoutStatistics')
            await dispatch('fetchPayoutList', {
                filters: {},
                pagination: { page: 1, page_size: 20 },
                sorting: {}
            })
            return result
        } catch (e) {
            throw new ApiException(e)
        }
    },
    
    async requestPayout({dispatch, getters}, {payoutId, data}) {
        try {
            // Richiede il pagamento fornendo fattura, IBAN e note
            const result = await service.requestPayout(getters.contractId, payoutId, data)
            await dispatch('fetchPayoutStatistics')
            await dispatch('fetchPayoutList', {
                filters: {},
                pagination: { page: 1, page_size: 20 },
                sorting: {}
            })
            return result
        } catch (e) {
            throw new ApiException(e)
        }
    },
    
    async deletePayout({dispatch, getters}, payoutId) {
        try {
            await service.deletePayout(getters.contractId, payoutId)
            await dispatch('fetchPayoutStatistics')
            await dispatch('fetchPayoutList', {
                filters: {},
                pagination: { page: 1, page_size: 20 },
                sorting: {}
            })
        } catch (e) {
            throw new ApiException(e)
        }
    },
    
    async fetchPayoutDetail({commit, getters}, id) {
        try {
            const payout = await service.fetchPayoutDetail(getters.contractId, id)
            commit('payout', payout)
            return payout
        } catch (e) {
            throw new ApiException(e)
        }
    },
    
    async downloadExcel({getters}, payoutId) {
        try {
            return await service.downloadExcel(getters.contractId, payoutId)
        } catch (e) {
            throw new ApiException(e)
        }
    },
    
    async downloadServiceExcel({getters}, {payoutId, serviceId}) {
        try {
            return await service.downloadServiceExcel(getters.contractId, payoutId, serviceId)
        } catch (e) {
            throw new ApiException(e)
        }
    }
})

export default payoutService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(payoutService)
})